// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const pageContent = (data: any) => {
  const { story } = data;

  const storyTags = story?.content?.tag || [];

  const contentTags = storyTags.map((tag: string) => ({
    id: '',
    name: tag,
  }));

  return {
    vvpm: [],
    indication: [],
    therapeuticArea: [],
    product: [],
    contentTags,
    contentHashtags: [],
    contentDuration: '',
    course: {},
  };
};
